import React, { useContext } from "react";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import VendorContext from "../../../contexts/VendorContext";
import { useLocation, useMatch, useNavigate } from "react-router-dom";
import { SocketContext } from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import PackingListDetail from "../PackingListDetail/PackingListDetail";

type Props = {};

export const PackingListDetailWrapper = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const vendorModel = useContext(VendorContext);

    const location = useLocation();
    const navigate = useNavigate();
    const match = useMatch("/packing_lists/:packing_list_guid");

    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    return (
        <PackingListDetail
            match={match}
            socket={socket}
            userModel={userModel}
            supplierModel={supplierModel}
            vendorModel={vendorModel}
            history={navigate}
            setActivityIndicator={uiContext.setActivityIndicator}
            setSidebarComponent={uiContext.setSidebarComponent}
            location={location}
            toggleSidebar={uiContext.toggleSidebar}
            notifyFn={uiContext.notifyFn}
            toggleMenu={uiContext.toggleMenu}
        />
    );
};
